import 'bootstrap/js/dist/collapse';
import './overlay';

$(document).ready(function () {
  Sceon.Filter = {};
  Sceon.Filter.url = '/escorts/get-filter';
  Sceon.Filter.params;
  Sceon.Filter.filter;
  Sceon.Filter.selected;
  Sceon.Filter.maxSelectCount = 4; // Infinity
  Sceon.LocationHash = {};

  Sceon.Filter.getForm = function () {
    let overlay = new Sceon.Overlay($('#and6-filters'), {
      loader: '/imgr/loader-tiny.gif',
      offset: { bottom: 0, top: 0 },
    });

    overlay.enable();

    let categoryName = location.pathname
      .replace('/', '')
      .replace('escorts/', '');

    let params = `?tmp=${Date.now()}`;
    setTimeout(() => {
      if (['gps-location'].includes(categoryName)) {
        if (
          Sceon.getPageCookie('position_latitude') &&
          Sceon.getPageCookie('position_longitude')
        ) {
          params = `&lat=${Sceon.getPageCookie(
            'position_latitude',
          )}&long=${Sceon.getPageCookie('position_longitude')}`;
        }
      }
      if (['nuove', 'gps-location', 'escorts'].includes(categoryName)) {
        categoryName = '';
      }

      const url = `${Sceon.Filter.url}/${categoryName}${params}`;

      $.ajax({
        url,
        method: 'GET',
        success: function (resp) {
          $('#and6-filters').html(resp);

          Sceon.Filter.init();
          Sceon.HashController.init();
          Sceon.PhotoRoller.init();

          Sceon.Escorts.onPrClick(location.hash.substring(1));

          if (Sceon.getPageCookie('showFilter') === 'true') {
            setTimeout(function () {
              $('#filter-toggle').click();
            }, 100);
          }
          overlay.disable();
        },
      });
    });
  };

  if (document.getElementById('and6-filters')) {
    Sceon.Filter.getForm();
  } else {
    setTimeout(() => {
      Sceon.HashController.init();
    });
  }

  Sceon.Filter.init = function () {
    Sceon.Filter.initSearchInput();
    Sceon.Filter.toggleFilters();
    Sceon.Filter.initMainCheckboxClick();
    Sceon.Filter.initDialogSubmit();
    Sceon.Filter.initDialogReset();
    Sceon.Filter.initReset();
    Sceon.Filter.initPopupCheckboxesClick();
    Sceon.LocationHash.setCheckboxesFromHash();
    Sceon.Filter.initSortChange();
    Sceon.Filter.initOthersDialogOpen();
    Sceon.Filter.initAreaMobileChange();
    Sceon.ListTypeChanges();
  };

  Sceon.Filter.initSearchInput = function () {
    const searchInput = $('#main-filters-form .search-by-name');
    const searchInputSm = $('#main-filters-form .search-by-name-sm');

    let timer = null;
    if (!searchInput.length) {
      return;
    }

    searchInputSm.keyup(() =>
      searchInput.val(encodeURI(searchInputSm.val())).trigger('keyup'),
    );

    searchInput
      .blur(function () {
        if ($(this).val().trim().length < 1) {
          $(this).val('');
        }
      })
      .keyup(function () {
        searchInputSm.val(decodeURI(searchInput.val()));
        clearTimeout(timer);
        timer = setTimeout(
          () => Sceon.LocationHash.Set(Sceon.LocationHash.Make()),
          500,
        );
      });
  };

  Sceon.Filter.initSortChange = function () {
    setTimeout(() => {
      document.querySelectorAll('.sort-select').forEach((select) => {
        select.onchange = function () {
          $('#main-filters-form .filter-header-lg .sort-select').val(
            $(this).val(),
          );
          $('#main-filters-form .filter-header-sm .sort-select').val(
            $(this).val(),
          );
          Sceon.LocationHash.Set(Sceon.LocationHash.Make());
        };
      });
    }, 50);
  };

  Sceon.Filter.toggleFilters = function () {
    $('#filter-toggle').on('click', function () {
      $(this).closest('.filter-container').toggleClass('open');
      if ($(this).closest('.filter-container').hasClass('open')) {
        Sceon.setPageCookie('showFilter', 'true');
      } else {
        Sceon.setPageCookie('showFilter', 'false');
      }
    });
  };

  Sceon.Filter.initMainCheckboxClick = function () {
    $('#main-filters-form .filter-checkbox').change(function () {
      let name = $(this).attr('name');
      let val = $(this).val();
      let checked = $(this).is(':checked');
      let checked_checkboxes = [];

      $('.filter-checkbox[name="' + name + '"]:checked').map(function (
        ind,
        el,
      ) {
        let el_val = $(el).val();
        if (!checked_checkboxes.includes(el_val)) {
          checked_checkboxes.push(el_val);
        }
      });
      let checked_count = checked_checkboxes.length;
      if (checked_count > Sceon.Filter.maxSelectCount) {
        $('.filter-checkbox[name="' + name + '"]:not(:checked)').prop(
          'disabled',
          true,
        );
      } else {
        $('.filter-checkbox[name="' + name + '"]:not(:checked)').prop(
          'disabled',
          false,
        );
      }
      if (!$(this).parents('.sc-dialog-form').length) {
        $('.filter-checkbox[name="' + name + '"][value="' + val + '"]').prop(
          'checked',
          checked,
        );
        if (name === 'sort') {
          $('.filter-checkbox[name="sort"]').prop('checked', false);
          $('.filter-checkbox[name="sort"][value="' + val + '"]').prop(
            'checked',
            true,
          );
          $('#main-filters-form .sort-select')
            .val(val)
            .trigger('change.select2');
        }
        Sceon.LocationHash.Set(Sceon.LocationHash.Make());
      }
    });
  };

  Sceon.Filter.initPopupCheckboxesClick = function () {
    $('.sc-checkbox-form .filter-checkbox').change(function () {
      let parent = $(this)
        .parents('.sc-filter-dialog')
        .find('.sc-checkbox-form');
      let key = $(parent).attr('id');
      let name = $(this).attr('name');
      let checked_count;

      if (key !== 'others') {
        checked_count = $(this)
          .closest('.sc-checkbox-form')
          .find('.filter-checkbox:checked').length;
      } else {
        checked_count = $(this)
          .closest('.accordion-collapse')
          .find('.filter-checkbox:checked').length;
      }

      if (checked_count > Sceon.Filter.maxSelectCount) {
        $('.filter-checkbox[name="' + name + '"]:not(:checked)').prop(
          'disabled',
          true,
        );
      } else {
        $('.filter-checkbox[name="' + name + '"]:not(:checked)').prop(
          'disabled',
          false,
        );
      }
    });
  };

  Sceon.Filter.initReset = function () {
    let hash = document.location.hash.substring(1);

    if (!hash.length) {
      $('.reset-btn').attr('hidden', 'hidden');
    } else {
      let sort_f = hash.split(';');
      if (
        sort_f.length === Sceon.Filter.maxSelectCount &&
        sort_f[0].includes('sort') &&
        sort_f[1].includes('reg') &&
        sort_f[2].includes('page')
      ) {
        $('.reset-btn').attr('hidden', 'hidden');
      } else if (
        (sort_f.length === 2 && sort_f[0].includes('sort')) === false
      ) {
        $('.reset-btn').removeAttr('hidden');
      } else {
        $('.reset-btn').attr('hidden', 'hidden');
      }
    }

    $('.reset-btn').on('click', function () {
      $('.filter-checkbox:checked').prop('checked', false);
      $('.filter-checkbox[name="sort"][value="DEFAULT"]').prop('checked', true);
      $('.search-input').val('');
      $('body').removeClass('overflow-hidden');
      if (!location.hash) {
        $('.close-btn').trigger('click');
        $('.text-primary-light').removeClass('text-primary-light');
        $('.filter-count').remove();
      } else {
        Sceon.LocationHash.Set('');
      }
    });
  };

  Sceon.Filter.initDialogSubmit = function () {
    $('.submit-btn').on('click', function () {
      let parent = $(this)
        .parents('.sc-filter-dialog')
        .find('.sc-checkbox-form');
      let key = $(parent).attr('id');

      if (key !== 'others') {
        let child = $(parent).find('.filter-checkbox')[0];
        let name = $(child).attr('name');

        let selected = $(parent).find('.filter-checkbox:checked');

        $('#main-filters-form')
          .find('.filter-checkbox[name="' + name + '"]')
          .prop('checked', false);

        selected.map(function (ind, el) {
          let val = $(el).val();
          $('.filter-checkbox[name="' + name + '"][value="' + val + '"]').prop(
            'checked',
            true,
          );
        });
      } else {
        $(parent)
          .find('.filter-checkbox')
          .map(function (ind, el) {
            let val = $(el).val();
            let name = $(el).attr('name');
            let checked = $(el).is(':checked');
            $(
              '.filter-checkbox[name="' + name + '"][value="' + val + '"]',
            ).prop('checked', checked);
          });
      }

      Sceon.LocationHash.Set(Sceon.LocationHash.Make());
    });
  };

  Sceon.Filter.initDialogReset = function () {
    $('.reset-category-btn').on('click', function () {
      let parent = $(this).parents('.sc-filter-dialog').find('.sc-dialog-form');
      let key = $(parent).attr('id');

      if (key !== 'others') {
        let child = $(parent).find('.filter-checkbox')[0];
        let name = $(child).attr('name');

        $('#main-filters-form')
          .find('.filter-checkbox[name="' + name + '"]')
          .prop('checked', false);
      } else {
        $(parent)
          .find('.filter-checkbox')
          .map(function (ind, el) {
            let val = $(el).val();
            let name = $(el).attr('name');
            $(
              '.filter-checkbox[name="' + name + '"][value="' + val + '"]',
            ).prop('checked', false);
          });
      }

      Sceon.LocationHash.Set(Sceon.LocationHash.Make());
    });
  };

  Sceon.Filter.setSelectedCount = function () {
    // $('.text-primary-light').removeClass('text-primary-light');
    if ($('.sc-dialog-others-form .filter-checkbox:checked').length) {
      $('.sc-dialog-others-form .filter-checkbox:checked').each(function (
        ind,
        el,
      ) {
        let name = $(el).attr('name');
        let checked_count = $(
          '#others .filter-checkbox[name="' + name + '"]:checked',
        ).length;
        let $target = $(el).closest('.accordion-item').find('.selected-count');

        if (checked_count) {
          $target.text(`(${checked_count})`);
        } else {
          $target.text('');
        }
      });
    }
  };

  Sceon.Filter.initOthersDialogOpen = function () {
    $('#sc-dialog-others').on('shown.bs.modal', function (event) {
      let tab = $(event.relatedTarget).attr('data-key');
      if (tab) {
        $('#sc-dialog-others').find(`#heading-${tab}`).removeClass('collapsed');
        $('#sc-dialog-others').find(`#collapse-${tab}`).addClass('show');
      }
    });
    $('#sc-dialog-others').on('hide.bs.modal', function (event) {
      $('#sc-dialog-others').find('.accordion-header').addClass('collapsed');
      $('#sc-dialog-others').find('.accordion-collapse').removeClass('show');
    });
  };

  Sceon.Filter.initAreaMobileChange = function () {
    $('.filter-area-select').on('change', (event) => {
      let sm = new Sceon.Overlay($('body'), {
        loader: '/img/loader-tiny.gif',
        offset: { bottom: 0, top: 0 },
      });
      sm.enable();

      window.location.href = event.target.value;
    });
  };

  Sceon.LocationHash.Set = function (hash) {
    if (hash.length) {
      document.location.hash = '#' + hash;
    } else {
      document.location.hash = '';
    }
    return false;
  };

  Sceon.LocationHash.Parse = function () {
    let hash = document.location.hash.substring(1);

    if (!hash.length) {
      return {};
    }

    let params = hash.split(';');

    let filter = '';

    let not_array_params = ['page', 'sort', 'reg', 'name'];

    params.map(function (param) {
      let key_value = param.split('=');

      let key = key_value[0];
      let val = key_value[1];

      if (val === undefined) return;

      val = val.split(',');

      val.map(function (it) {
        filter +=
          key + (!not_array_params.includes(key) ? '[]=' : '=') + it + '&';
      });
    });

    return filter;
  };

  Sceon.LocationHash.Make = function (params) {
    let hash = '';
    let sep = ';';
    let value_glue = ',';

    let map = {};
    $('.filter-checkbox:checked').map(function (index, el) {
      let val = $(el).val();
      let name = $(el).attr('name');
      if (val !== undefined) {
        name = name.replace('[]', '');
        if (map[name] === undefined) {
          map[name] = [];
        }
        if (!map[name].includes(val)) {
          map[name].push(val);
        }
      }
    });
    if ($('#main-filters-form .sort-select').length) {
      let sort_by = $('#main-filters-form .sort-select').val();
      map['sort'] = [sort_by];
    }
    if ($('#main-filters-form .search-by-name').length) {
      let search = decodeURI(
        $('#main-filters-form .search-by-name').val(),
      ).trim();
      if (search !== '' && search.length >= 3) {
        map['name'] = [search];
      }
    }
    map = {
      ...map,
      ...params,
    };
    for (let i in map) {
      hash += i + '=' + map[i].join(value_glue) + sep;
    }

    return hash;
  };

  Sceon.LocationHash.setCheckboxesFromHash = function () {
    let hash = document.location.hash.substring(1);

    $('.filter-checkbox').prop('disabled', false);

    if (!hash.length) {
      Sceon.Filter.setSelectedCount();
      return {};
    }

    let params = hash.split(';');
    let not_array_params = ['sort', 'name', 'vr', 'video'];
    params.map(function (param) {
      if (param === '') return;
      param = param.split('=');
      let name = param[0];
      if (!not_array_params.includes(name)) {
        name = name + '[]';
      }
      let values = param[1]?.split(',');
      if (values?.length) {
        values.map(function (value) {
          $(
            '.filter-checkbox[name="' + name + '"][value="' + value + '"]',
          ).prop('checked', 'true');
        });
        if (values.length > Sceon.Filter.maxSelectCount) {
          $('.filter-checkbox[name="' + name + '"]:not(:checked)').prop(
            'disabled',
            true,
          );
        }
        if (name === 'sort') {
          $('#main-filters-form .sort-select')
            .val(values[0])
            .trigger('change.select2');
        }
        if (name === 'name') {
          $('.search-input').val(decodeURI(values[0].replace(/%20/g, ' ')));
        }
      }
    });
    Sceon.Filter.setSelectedCount();
  };

  Sceon.HashController = {
    _current: '',

    init: function () {
      window.onhashchange = function () {
        Sceon.HashController.check();
      };
      Sceon.HashController.check();
    },

    check: function () {
      const loaderElement = $('.main-listing-container .loader');
      const isMobileLoading = loaderElement.hasClass('loader-active');
      const prevHash = this._current;
      let hash = document.location.hash.substring(1);
      // const mobileView = $('#sc-dialog-mobile-view');
      const page = parseInt(hash.split(';page=')[1]) || 1;

      if (hash !== this._current) {
        this._current = hash;

        let data = Sceon.LocationHash.Parse();
        Sceon.Escorts.Load(
          hash,
          data,
          isMobileLoading,
          !prevHash &&
            !!loaderElement?.length &&
            this._current.includes('page='),
        );
      }

      if (loaderElement) {
        Sceon.Scroll.init({ page: page });
      } else {
        Sceon.Scroll.removeScroll();
      }
    },
  };

  Sceon.Filter.Set = function (params, isScroll) {
    if (isScroll) {
      return Sceon.LocationHash.Set(Sceon.LocationHash.Make(params));
    }

    const listingHeader = $('.listing-header-container');
    Sceon.LocationHash.Set(Sceon.LocationHash.Make(params));
    let top = 0;
    let time = 500;
    if (listingHeader.length) {
      top = listingHeader.offset().top;
      time = 1000;
    } else if ($('.sc-subheader').length) {
      top = $('.sc-subheader').offset().top;
      time = 500;
    }
    $('html, body').animate({ scrollTop: top }, time);
  };
});
